import { config } from '@config'
import { OrderType } from '@modules/common/models/enums/OrderManagement'
import { HttpService } from '@services/HttpService'
import { storage } from '@services/storageService'
import OrderDataService from './OrderDataService'
import { ORDER_SERVICE_ENDPOINTS } from '../constants/apiConstants'
import sortObjectValues from '@utils/sorting-object-values'
import sortArrayofObjectUsingProperty from '@utils/string-sort'
import { PRODUCT_SERVICE_ENDPOINTS } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'
export default class ProductDataService extends OrderDataService {
  httpService = new HttpService()

  getOptionsHeader = () => {
    const accessToken: string = storage.getItem('access_token')
    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }
  }

  fetchHierarchy = (
    bsgId,
    orderId,
    orderType,
    filterData = [],
    searchKey = '',
    clientOrderId
  ) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrderId/${orderId}`
        : `/clientOrderId/${clientOrderId}/doorOrderId/${orderId}`
    // const orderPath = `/${orderType ?? OrderType.Client}OrderId/${orderId}`
    const url = `${config.buyingBoardServiceRestEndpoint}${ORDER_SERVICE_ENDPOINTS.GET_ORDER_PRODUCTS_HIERARCHY}/buyingSessionGroupId/${bsgId}${orderPath}`
    const body = {
      filter: filterData
    }
    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader(),
        params: {
          ...(searchKey ? { searchKey } : {})
        }
      })
      .then(response => response.data?.data?.productHierarchy?.categories)
  }

  fetchProductsByHierarchy = (
    bsgId: string,
    orderId: string,
    orderType: string,
    filterData = {},
    searchKey = '',
    includeTotalQty = false
  ) => {
    const orderPath = `/${orderType ?? OrderType.Client}OrderId/${orderId}`
    const url = `${config.buyingBoardServiceRestEndpoint}${ORDER_SERVICE_ENDPOINTS.GET_PRODUCTS}/buyingSessionGroupId/${bsgId}${orderPath}`
    const body = {
      filter: filterData
    }
    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader(),
        params: {
          ...(searchKey ? { searchKey } : {}),
          includeTotalQty
        }
      })
      .then(response => response.data?.data?.products)
  }

  fetchFilterAttributes = (bsgId: string, orderId: string, orderType: string) => {
    const orderPath = `/${orderType ?? OrderType.Client}Order/${orderId}`
    const url = `${config.buyingBoardServiceRestEndpoint}${ORDER_SERVICE_ENDPOINTS.GET_FILTER_ATTRIBUTES}/buyingSessionGroup/${bsgId}${orderPath}`
    return this.httpService
      .get(url, {
        ...this.getOptionsHeader()
      })
      .then(response => {
        const sortingKeys = ['wholesaleFreeTag', 'retailFreeTag']
        sortObjectValues(
          sortingKeys,
          response.data?.data?.filterAttributes,
          'label',
          sortArrayofObjectUsingProperty
        )
        return response.data?.data?.filterAttributes
      })
  }

  fetchOrderProductGroups = (bsgId, orderId, orderType, clientOrderId, body) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrder/${orderId}/multiple-aggregates`
        : `/clientOrder/${clientOrderId}/doorOrder/${orderId}/multiple-aggregates`
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
  }

  fetchProductsByGrouping = (bsgId, orderId, orderType, clientOrderId, body) => {
    const orderPath =
      orderType === OrderType.Client
        ? `/clientOrder/${orderId}/products`
        : `/clientOrder/${clientOrderId}/doorOrder/${orderId}/products`

    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
  }
}
